export const commonStyles =
  "w-full px-5 py-4 rounded-lg transition-colors border";
export const variantStyles = {
  light: {
    enabled:
      "bg-white text-blue-dark placeholder:text-blue-dark60 border-blue-dark20",
    disabled:
      "bg-blue-dark20 text-blue-dark40 placeholder:text-blue-dark60 border-blue-dark20",
  },
  dark: {
    enabled:
      "bg-grey-light text-blue-dark border-blue-dark20 active:border-blue-200 placeholder:text-blue-100",
    disabled:
      "bg-grey-primaryExtra text-blue-dark border-blue-dark20 active:border-blue-200 placeholder:text-blue-100",
  },
};
